/* eslint-disable @next/next/no-img-element */
import clsx from 'clsx';
import Image from 'next/image';
import NextImage from 'next/image';
import Link from 'next/link';
import Script from 'next/script';

import { Column, Padded } from './column';

export function Footer() {
  return (
    <footer className='flex flex-wrap justify-center bg-[#cbd5e1] w-full min-h-[5rem] py-6'>
      <Column>
        <Padded className='grid sm:grid-cols-2 md:grid-cols-[1fr_256px] justify-center gap-4 max-w-viewport w-full py-2 '>
          <div>
            <Link
              className='flex items-center gap-2 text-xl md:text-3xl no-underline'
              href='/'
              style={{ textDecoration: 'none !important' }}
            >
              <NextImage alt='logo' src='/images/logos/logo-dark.png' width={44} height={39.5} />
              Therapy Animal Hub
            </Link>
          </div>
          <Image
            alt='Money back guarantee'
            className='relative right-[-9px]'
            height={44.6}
            src='/images/landing/footer/money-back-guarantee.png'
            style={{ justifySelf: 'center' }}
            width={256}
          />
        </Padded>

        <Padded className='flex flex-wrap justify-center md:justify-between gap-4 w-full max-w-viewport py-6'>
          <LinkStack title='company'>
            <Link href='/satisfaction-guaranteed'>Satisfaction Guaranteed</Link>
            <Link href='/partner/onboarding'>Become a partner</Link>
            <Link href='/terms-and-conditions'>Terms and Conditions</Link>
            <Link href='/privacy'>Privacy</Link>
          </LinkStack>
          <LinkStack
            // css={{ flex: [0, 0, 0, 1] }}
            title='Help'
          >
            <Link href='/contact'>Customer Support</Link>
            <Link href='/resources'>Resources</Link>
            <Link href='/#faqs'>FAQs</Link>
          </LinkStack>

          <div
            className='flex flex-col gap-4 w-full sm:w-auto sm:min-w-fit lg:min-w-fit'
            // css={{ gap: 8, flex: [0, 0, 0, 1] }} layout='flexColumn'
          >
            <LinkStack title='email us'>
              <Link href='mailto:contact@therapyanimalhub.com'>
                <span>
                  <span>contact</span>
                  <span> @therapyanimalhub.com</span>
                </span>
              </Link>
            </LinkStack>
          </div>
          <div className='flex flex-col items-center gap-4 pt-10 xl:pt-0 w-full 2xl:w-auto'>
            <Script id='bbb' src='https://seal-necal.bbb.org/inc/legacy.js' type='text/javascript' />
            <a
              className='ruhzbum'
              href='https://www.bbb.org/us/ca/truckee/profile/pet-services/therapy-animal-hub-1156-90096791/#sealclick'
              id='bbblink'
              rel='nofollow'
              target='_blank'
            >
              <img
                alt='Therapy Animal Hub BBB Business Review'
                src='https://seal-necal.bbb.org/logo/ruhzbum/bbb-90096791.png'
              />
            </a>
            <Image
              alt='stripe credit cards'
              height={64}
              src='/images/landing/footer/credit-cards.png'
              style={{ margin: '0 -1rem' }}
              width={369}
            />
          </div>
        </Padded>
        <Padded className='flex flex-col sm:flex-row items-center justify-between gap-4 w-full max-w-viewport border-t pt-4'>
          <span className='text-sm text-center sm:text-left'>
            © {new Date().getFullYear()} Therapy Animal Hub. All rights reserved.
          </span>
          <div className='flex gap-4'>
            <Link href='https://www.facebook.com/therapyanimalhub'>
              <Image alt='facebook' height={16} src='/images/landing/footer/fb.png' width={9} />
            </Link>
            <Link href='https://www.instagram.com/therapyanimalhub/'>
              <Image alt='instagram' height={18} src='/images/landing/footer/insta.png' width={19} />
            </Link>
          </div>
        </Padded>
      </Column>
    </footer>
  );
}

function LinkStack({
  children,
  title,
  className,
  ...divProps
}: { children: React.ReactNode; title: string } & React.ComponentProps<'div'>) {
  return (
    <div className={clsx(className, 'flex flex-col gap-2 text-sm min-w-[150px] sm:min-w-[100px]')} {...divProps}>
      <span style={{ textTransform: 'uppercase', fontSize: '13px', fontWeight: 700, paddingBottom: 4 }}>{title}</span>
      {children}
    </div>
  );
}
